<template>
  <div class="bg">
    <component :is="bgComponent" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { hasWebGL, prefersReducedMotion } from '../services/capability'
import HeroScene from './HeroScene.vue'
import HeroFallback from './HeroFallback.vue'

const bgComponent = computed(() => {
  if (prefersReducedMotion() || !hasWebGL()) return HeroFallback
  return HeroScene
})
</script>

<style scoped>
.bg {
  position: fixed;
  inset: 0;
  z-index: 0; /* behind page content wrapper but above body background */
  pointer-events: none; /* let UI be interactive */
}
/* Canvas already stretches via .scene inside HeroScene */
</style>
